import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue'

  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import TextRenderer from '@/components/editor/TextRenderer.vue'

  import { useRoute } from 'vue-router/composables'
  import useIcons from '@/composables/useIcons'
  import useEditor from '@/composables/useEditor'

  import UsersApi from '@/services/api/UsersApi'

  import { UserModule } from '@/store/modules/user'

  import type { PropType } from 'vue'
  import type { MemberGroup } from '@/services/interfaces/Auth0'
  import type { EditorStatePayload } from '@/services/interfaces/Course'

  import eventBus from '@/main'
  import * as Sentry from '@sentry/vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'UserGroupEditor',
  props: {
    group: {
      type: Object as PropType<MemberGroup>,
      required: true,
    },
    cancel: {
      type: Function as PropType<(groupId: string) => void>,
      required: true,
    },
  },
  emits: ['reset-editing-key', 'reload-user-members'],
  setup(__props, { emit }) {

const props = __props;

  

  

  const route = useRoute()
  const { checkmark, checkboxSquare, checkboxSquareChecked } = useIcons()
  const { hasLocalChanges } = useEditor(route)

  const payload = ref<{
    [key: string]: {
      id: string
      name: string
      description?: string
      includeInGroupProfileQuestion: boolean
      colorId?: string
    }
  }>({})
  const isSubmitting = ref(false)

  const canSaveGroupDetails = computed(() => {
    if (!payload.value[props.group.id]?.name) return false
    return hasLocalChanges.value(props.group, payload.value[props.group.id])
  })

  const mutateAndQueueFunc = (groupId: string) => {
    return async (data: EditorStatePayload) => {
      const currentData: any = payload.value[groupId]

      eventBus.$set(payload.value, groupId, {
        ...currentData,
        id: groupId,
        [data.property as string]: data.value,
      })
    }
  }

  const toggleIncludeInProfileQuestion = (groupId: string) => {
    payload.value[groupId].includeInGroupProfileQuestion = !payload.value[groupId].includeInGroupProfileQuestion
  }

  const onSubmit = async (group: MemberGroup) => {
    if (group.name === 'All  Users') return
    isSubmitting.value = true

    const data = payload.value[group.id]
    try {
      if (group.id === '') {
        Object.assign(data, { id: undefined })
        await UsersApi.createMemberGroup(UserModule.currentCompany!.id, data)
      } else {
        await UsersApi.updateMemberGroup(UserModule.currentCompany!.id, data)
        emit('reload-user-members')
        emit('reset-editing-key')
      }
      eventBus.$delete(payload.value, group.id)
      await UserModule.getMembersGroups()
      await UserModule.getCompanyActivityLog()
    } catch (error) {
      Sentry.captureException(error)
    }
    isSubmitting.value = false
  }

  const populatePayload = () => {
    if (props.group) {
      eventBus.$set(payload.value, props.group.id, {
        ...props.group,
        id: props.group.id,
      })
    }
  }

  onMounted(() => {
    populatePayload()
  })

return { __sfc: true,props, emit, route, checkmark, checkboxSquare, checkboxSquareChecked, hasLocalChanges, payload, isSubmitting, canSaveGroupDetails, mutateAndQueueFunc, toggleIncludeInProfileQuestion, onSubmit, populatePayload, computed, onMounted, ref, SVGRenderer, KetchUpButton, LoadingSpinner, TextRenderer, useRoute, useIcons, useEditor, UsersApi, UserModule, eventBus, Sentry }
}

})